import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["prefixCls", "className", "children", "dashed", "type", "align"];
import React from 'react';
import "./style/index.css";
import { jsx as _jsx } from "react/jsx-runtime";
export default /*#__PURE__*/React.forwardRef((props, ref) => {
  var {
      prefixCls = 'w-divider',
      className,
      children,
      dashed = false,
      type = 'horizontal',
      align = 'center'
    } = props,
    restProps = _objectWithoutPropertiesLoose(props, _excluded);
  var cls = [className, prefixCls, prefixCls && type ? prefixCls + "-" + type : null, prefixCls && align ? prefixCls + "-" + align : null, children ? prefixCls + "-with-text" : null, !!dashed ? prefixCls + "-dashed" : null].filter(Boolean).join(' ').trim();
  return /*#__PURE__*/_jsx("div", _extends({
    className: cls
  }, restProps, {
    ref: ref,
    children: children && /*#__PURE__*/_jsx("span", {
      className: prefixCls + "-inner-text",
      children: children
    })
  }));
});